import LoginModal from "@/src/components/Auth/Login/LoginModal";
import { Button, Typography } from "@material-tailwind/react";
import { useRouter } from "next/router";
import React, { useState } from "react";

const Callout = () => {
  const router = useRouter();
  const [loginModalOpen, setLoginModalOpen] = useState(false);

  const onLoginSuccess = () => {
    router.reload();
  };

  return (
    <>
      <div className="flex flex-col p-4 rounded content-center items-center text-center">
        <Typography variant="h2" className="text-center">
          This article is for 👑&nbsp;
          <span className={"text-scpb-light-blue font-bold"}>
            Subscribers
          </span>{" "}
          only
        </Typography>
        <Typography variant="paragraph">
          Subscribe now to get access to exclusive leading Supercoach content
          year round.
        </Typography>
        <Typography variant="paragraph">
          All year content of AFL, BBL , NRL.
        </Typography>
        <Typography variant="h6">Check out our subscriptions below</Typography>
        <Typography
          variant="h6"
          className="cursor-pointer"
          onClick={() => setLoginModalOpen(true)}
        >
          Already Subscribed?{" "}
          <span className={"text-scpb-light-blue"}>Login</span>
        </Typography>
      </div>
      <LoginModal
        open={loginModalOpen}
        setOpen={setLoginModalOpen}
        onSuccess={() => {
          onLoginSuccess();
        }}
      />
    </>
  );
};

export default Callout;
